import "./TeamBanner.scss";
import { useRecoilState } from "recoil";
import { availableAddonsState } from "../../state/atoms";
import { useMemo } from "react";
import { getUserAddonPrice } from "../../service/SubscriptionService";
import Price from "./misc/Price";
import { SubStatusDtoPlanCycleEnum } from "../../generated/account-client";
import { UserOutlined } from "@ant-design/icons";

export default function TeamBanner() {
  const [availableAddons] = useRecoilState(availableAddonsState);
  const userAddonPrice = useMemo(
    () => getUserAddonPrice(availableAddons),
    [availableAddons]
  );

  return (
    <section className={"promo-banner team-banner"}>
      <h3>My Team</h3>
      <p>
        Work better, together. Add your team for{" "}
        <Price
          amount={userAddonPrice}
          cycle={SubStatusDtoPlanCycleEnum.Monthly}
          light
        />{" "}
        per user.
      </p>
      <div className={"circle"}><UserOutlined/></div>
    </section>
  );
}
